import ReactGA4 from "react-ga4";
import Cookies from "js-cookie";
import { GA4_ID } from "../../constants";
import { COOKIE_LOG_TRACKING_CLIENT_ID } from "../../constants/cookie";

const setUserProperties = (profile) => {
  ReactGA4.gtag("set", "user_properties", {
    "subscription_status": profile?.isVip ? 1 : 0,
    "member_status": profile?.accountId ? 1 : 0,
    "instance_id": Cookies.get(COOKIE_LOG_TRACKING_CLIENT_ID) || "",
  });
  ReactGA4.gtag("config", GA4_ID, {"user_id": profile?.accountId || ""});
};

export const ga4SearchDrama = (profile, searchText) => {
  setUserProperties(profile);
  ReactGA4.event("Search_drama", {
    Search_text: searchText,
  });
};

export const ga4RegisterSuccess = (profile, registrationMethod) => {
  setUserProperties(profile);
  ReactGA4.event("register_success", {
    registration_method: registrationMethod,
  });
};

export const ga4SubscriptionPayClick = (profile, source, campaign) => {
  setUserProperties(profile);
  ReactGA4.event("Subscription_Pay_Click", {
    Source: source,
    Campaign: campaign,
  });
};

export const ga4SubscriptionSuccess = (profile, source, campaign, price) => {
  setUserProperties(profile);
  ReactGA4.event("Subscription_Success", {
    Source: source,
    Campaign: campaign,
    Price: price,
  });
};

export const ga4ContentPlay = (profile, data) => {
  setUserProperties(profile);
  ReactGA4.event("content_play", data);
};

export const ga4ContentEffectivePlay = (profile, data) => {
  setUserProperties(profile);
  ReactGA4.event("content_effective_play", data);
};

export const ga4BehindContentEffectivePlay = (profile, data) => {
  setUserProperties(profile);
  ReactGA4.event("behind_content_effective_play", data);
};

export const ga4DlAPP = (profile) => {
  setUserProperties(profile);
  ReactGA4.event("DL_APP");
};

export const ga4AppFunctionFavorite = (profile, contentId, contentName) => {
  setUserProperties(profile);
  ReactGA4.event("app_function_favorite", {
    content_id: contentId,
    content_name: contentName,
  });
};

export const ga4AppFunctionComment = (profile, contentId, contentName, contentText) => {
  setUserProperties(profile);
  ReactGA4.event("app_function_comment", {
    content_id: contentId,
    content_name: contentName,
    content_text: contentText,
  });
};
